import React, { useEffect, useState } from 'react'
import { ObtenerHistoricoMonedaAsync } from '../Servicios/ServiciosPublicos';
import { Chart, Line, Point, Tooltip, getTheme } from "bizcharts";

import moment from 'moment';
import { Dropdown, DropdownDivider, DropdownHeader, DropdownItem, DropdownMenu, Label } from 'semantic-ui-react';
import numeral from 'numeral';

export const GraficaMoneda = (params) => {

    //#region internalState
    const [internalState, setInternalState] = useState({
        Load: false,
        MonedaDetalle: params.MonedaDetalle,
        Lista: [],
        Tipo: 1,
        PMax: 0,
        PMin: 0,
        PPro: 0,

    })
    //#endregion

    //#region useEffect
    useEffect(() => { Load(); }, []);
    useEffect(() => { console.log(internalState.Lista); }, [internalState.Lista]);
    useEffect(() => { ObtenerGrafica(); }, [internalState.Tipo]);
    //#endregion
    //#region Metodos
    const Load = async () => { }
    const ObtenerGrafica = async () => {
        let book = `${internalState.MonedaDetalle.Item.Clave}_mxn`;
        let _lista = await ObtenerHistoricoMonedaAsync(book, internalState.Tipo);
        let PMax = 0;
        let PMin = 0;
        let PPro = 0;
        _lista = _lista.map(f => {
            if (!PMin) { PMin = f.Precio; }
            if (f.Precio >= PMax) { PMax = f.Precio; }
            if (f.Precio <= PMin && !!f.Precio) { PMin = f.Precio; }
            PPro += f.Precio;
            return {
                book,
                date: moment(f.Fecha).format("HH:mm:ss"),
                value: f.Precio,
            }
        });
        let _count = !!_lista.length ? _lista.length : 1;
        PPro = PPro / _count;
        setInternalState((state) => ({ ...state, Lista: _lista, PMax, PMin, PPro }));
    }
    const OnTipo = async (Tipo) => {
        //1.- 1 hora
        //2.- 1 día
        //3.- 5 días
        //4.- 1 mes
        setInternalState((state) => ({ ...state, Tipo }));
    }
    const ONR = () => {
        let _nombre = "1 hora";
        switch (internalState.Tipo) {
            case 1: _nombre = "1 hora"; break;
            case 2: _nombre = "1 día"; break;
            case 3: _nombre = "5 días"; break;
            case 4: _nombre = "1 mes"; break;
            default: break;
        }


        return _nombre;
    }
    //#endregion


    if (!internalState.Lista.length) {
        return (<></>)
    }
    return (<>
        <div style={{ display: "flex" }}>
            <div style={{ marginRight: "10px" }}>
                <Dropdown
                    text={`Línea de Tiempo: ${ONR()}`}
                    icon='filter'
                    floating
                    labeled
                    button
                    selection
                    className='icon'
                >
                    <DropdownMenu>
                        <DropdownHeader icon='tags' content='Filtrar por' />
                        <DropdownDivider />
                        <DropdownItem onClick={() => { OnTipo(1); }}><div style={{ color: "black" }}>1 Hora</div></DropdownItem>
                        <DropdownItem onClick={() => { OnTipo(2); }}><div style={{ color: "black" }}>1 Día</div></DropdownItem>
                        <DropdownItem onClick={() => { OnTipo(3); }}><div style={{ color: "black" }}>5 Días</div></DropdownItem>
                        <DropdownItem onClick={() => { OnTipo(4); }}><div style={{ color: "black" }}>1 Mes</div></DropdownItem>
                    </DropdownMenu>
                </Dropdown >
            </div>
            <div style={{ marginRight: "10px" }}> <Label color='red'>Precio Mínimo: {numeral(internalState.PMin).format("0,000.00[000000]")}</Label></div>
            <div style={{ marginRight: "10px" }}><Label color='green'>Precio Máximo: {numeral(internalState.PMax).format("0,000.00[000000]")}</Label></div>
            <div style={{ marginRight: "10px" }}><Label color='blue'>Precio Promedio: {numeral(internalState.PPro).format("0,000.00[000000]")}</Label></div>
        </div>

        <Chart
            appendPadding={[10, 0, 0, 10]}
            autoFit
            height={300}
            data={internalState.Lista}
            onLineClick={console.log}
            scale={{
                value: {
                    min: 9990000,
                    alias: "Precio",
                    type: 'linear-strict'
                },
                date: {
                    range: [0, 1]
                }
            }}
        >
            <Line position="date*value" />
            <Point position="date*value" />
            <Tooltip showCrosshairs follow={true} />
        </Chart>
    </>)
}
